import palette from './palette'
import props from './props'
import overrides from './overrides'

export default {
  palette,
  props,
  overrides
}
